import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import { trackAppRouteEvent } from '@/actions/trackEvent';
import * as AnalyticEvents from '@/utils/analytics';
import { ReleaseCalendar } from '@/components/ReleaseCalendar';
import { ReleaseCalendar as ReleaseCalendarV2 } from '@/components/ReleaseCalendarV2/ReleaseCalendar';
import { AppComponentProps } from '@/typescriptHelpers';
import { useTrackPageView } from '@/helpers/trackingHelpers';
import { RootState } from '@/reducers/reducers';
import { selectOrg } from '@/selectors/selectors';
import { useShouldShowNewReleaseCalendar } from '@/utils/internalFeatureFlags';

const AppReleaseCalendar: React.FC<AppComponentProps> = (props: AppComponentProps) => {
    const dispatch = useDispatch();
    const org = useSelector((state: RootState) => selectOrg(state, props.orgId));
    const shouldShowNewReleaseCalendar = useShouldShowNewReleaseCalendar(org);

    React.useEffect(() => {
        dispatch(
            trackAppRouteEvent({
                orgId: props.orgId,
                appId: props.appId,
                eventName: AnalyticEvents.Event.ViewAppReleaseCalendar,
            }),
        );
    }, []);

    useTrackPageView('Release schedule');

    if (shouldShowNewReleaseCalendar) {
        return <ReleaseCalendarV2 orgId={props.orgId} appId={props.appId} />;
    }

    return <ReleaseCalendar orgId={props.orgId} appId={props.appId} />;
};

export default AppReleaseCalendar;
